<template>
	<div class="reports-detail-view">
		<main-section-reports-detail></main-section-reports-detail>
	</div>
</template>

<script>
	import ReportsDetailView from "@/components/main-section-reports-detail.vue";

	export default {
		components: {
			"main-section-reports-detail": ReportsDetailView,
		},
	};
</script>

<style scoped>
	/* Add your scoped styles here */
</style>
